// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    apiUrl: 'https://api.taptapmedicare.com',
    //apiUrl: 'https://stagev2api.taptapmedicare.com',
    // apiUrl: 'http://localhost:8000',
    production: false,
    recaptcha: {
        siteKey: '6LfYbNYUAAAAADJgUKeiBbQRZf03bRx-rjQLA1FA',
    },
    firebaseConfig: {
        apiKey: 'AIzaSyCWPLj_jTCDYO9pVI6ePN6K9FY38SIZbjk',
        authDomain: 'taptapdev-app.firebaseapp.com',
        databaseURL: 'https://taptapdev-app.firebaseio.com',
        projectId: 'taptapdev-app',
        storageBucket: 'taptapdev-app.appspot.com',
        messagingSenderId: '756188358350'
    }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
